import { useGetAppointments } from "@/features/appointments/hooks/useGetAppointments"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { useDnaTest } from "@/features/holifya-tests/dna-test/hooks/useDnaTest"
import { useMembership } from "@/features/membership/hooks/useMembership"
import { SubType } from "@/features/membership/types/SubType"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import CloseButton from "../../../pages/new-platform/components/CloseButton"
import { saveEvent } from "../../../utils/apis/user-service"
import { useUserStore } from "../../../utils/stores/useUserStore"
import ControlPanelPageContentArea from "../components/controlPanelPage/ControlPanelPageContentArea"
import { usePercentageRing } from "../hooks/usePercentageRing"

const ControlPanelPage = () => {
  const { sendEvent } = useCreateEvent()
  const { userData } = useUserStore()
  const email = userData.email
  const navigate = useNavigate()
  const membership = useMembership()
  const { refetch } = useGetAppointments()

  const { dnaTestUser} = useDnaTest()
  const { getTotalDnaPercentage, getTotalBloodPercentage, getTotalClinicalHistoryPercentage, isPercentageRingVisible} = usePercentageRing()
  const totalPercentage = dnaTestUser ? getTotalDnaPercentage().percentage : membership === SubType.HEALTH ? ((getTotalBloodPercentage().percentage*getTotalBloodPercentage().numberOfItems + getTotalClinicalHistoryPercentage().percentage*getTotalClinicalHistoryPercentage().numberOfItems)/ (getTotalClinicalHistoryPercentage().numberOfItems + getTotalBloodPercentage().numberOfItems)) : 0

  useEffect(() => {
    if (!email) return
    saveEvent(
      email,
      "page_view",
      () => { },
      () => { },
      "control_panel_page",
    )

    void sendEvent({
      event: EventType.PAGE_VIEW,
      sub_category: "control_panel_page",
    })
  }, [])

  useEffect(() => {
    refetch()
  }, [])

  return (
    <div className="w-full h-full space-y-[20px]">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center">
          <div className="font-bold text-[15px] mr-[20px]">
            Health Hub
          </div>
          {/* {isPercentageRingVisible && <PercentageRing percentage={totalPercentage} />} */}
        </div>
        <CloseButton onClick={() => navigate("/home")} />
      </div>
      <div className="space-y-[20px] max-w-[800px] pb-[20px]">
        {/* TODO[TM]: Aspetta i testi ufficiali */}
        {/* <ControlPanelPageHeader focusElement={focusElement} /> */}
        <ControlPanelPageContentArea />
      </div>
    </div>
  )
}

export default ControlPanelPage
